/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateOrUpdateTaskItemAreaDataDto } from './CreateOrUpdateTaskItemAreaDataDto';
import {
    instanceOfCreateOrUpdateTaskItemAreaDataDto,
    CreateOrUpdateTaskItemAreaDataDtoFromJSON,
    CreateOrUpdateTaskItemAreaDataDtoFromJSONTyped,
    CreateOrUpdateTaskItemAreaDataDtoToJSON,
} from './CreateOrUpdateTaskItemAreaDataDto';

/**
 * @type CreateOrUpdateTaskItemAreaDtoTaskTypeData
 * 
 * @export
 */
export type CreateOrUpdateTaskItemAreaDtoTaskTypeData = CreateOrUpdateTaskItemAreaDataDto;


export function CreateOrUpdateTaskItemAreaDtoTaskTypeDataFromJSON(json: any): CreateOrUpdateTaskItemAreaDtoTaskTypeData {
    return CreateOrUpdateTaskItemAreaDtoTaskTypeDataFromJSONTyped(json, false);
}

export function CreateOrUpdateTaskItemAreaDtoTaskTypeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateTaskItemAreaDtoTaskTypeData {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CreateOrUpdateTaskItemAreaDataDtoFromJSONTyped(json, true) };
    return  CreateOrUpdateTaskItemAreaDataDtoFromJSONTyped(json, true);
}

export function CreateOrUpdateTaskItemAreaDtoTaskTypeDataToJSON(value?: CreateOrUpdateTaskItemAreaDtoTaskTypeData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCreateOrUpdateTaskItemAreaDataDto(value)) {
        return CreateOrUpdateTaskItemAreaDataDtoToJSON(value as CreateOrUpdateTaskItemAreaDataDto);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOrUpdateTaskItemAreaDtoTaskTypeData interface.
 */
export function instanceOfCreateOrUpdateTaskItemAreaDtoTaskTypeData(value: any): value is CreateOrUpdateTaskItemAreaDtoTaskTypeData {
    if (instanceOfCreateOrUpdateTaskItemAreaDataDto(value)) return true;
    return false;
}

